/* ModeRenderer.js */

"use strict";

const MODE_VALUES = {
    CRAWL: "Neighbor Crawl",
    SCAN: "Subnet Scan",
};

class ModeColumnRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("mode-column");
        this._rootElem.component = this._model;

        this._registerListeners();
        this.render();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _shutdown() {
        return new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();

            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
    }

    _registerListeners() {
        this._model.on("Mode", (this._onMode = this._onMode.bind(this)));
    }

    _unregisterListeners() {
        this._model.removeAllListeners("Mode");
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */

    render() {
        this._setMode(this._model.getMode());
        return Promise.resolve();
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onMode(newVal) {
        this._setMode(newVal);
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _setMode(newVal) {
        const val = MODE_VALUES[newVal] || "";
        this._rootElem.innerHTML = val;
    }

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = ModeColumnRenderer;
